import React from 'react'
import styled from '@emotion/styled'

import Icon from '../Icon'

export const FeatureWarningIconStyled = styled(({ className }) => (
  <Icon
    className={className}
    icon="alert_exclamation_triangle_solid"
    fill="alertWarningBgColor"
    size="medium"
  />
))`
  && {
    width: 24px;
  }
  position: absolute;
  z-index: 2;
  right: 4px;
  top: 6px;
`

export const FragmentWarningIconStyled = styled(({ className }) => (
  <Icon
    className={className}
    icon="warning_banner_black_exclaim"
    fill="alertWarningBgColor"
    size="small"
  />
))`
  && {
    width: 20px;
    height: 12px;
  }
  && path:last-of-type {
    fill: black;
  }
`

export const PendingChangesIcon = styled(({ className }) => (
  <Icon
    className={className}
    icon="alert_exclamation_triangle_solid"
    fill="warningPrimary"
    size="medium"
  />
))`
  && {
    width: 24px;
  }
  z-index: 2;
`

export const EvaluationIconStyled = styled(
  ({ className, evaluation, useNodeStyles }) => (
    <Icon
      className={className}
      icon={evaluation ? 'success_solid' : 'remove_circle'}
      size={useNodeStyles ? 'large' : 'small'}
      fill={evaluation ? 'alertSuccessBgColor' : 'alertErrorBgColor'}
    />
  )
)`
  ${({ useNodeStyles, theme: { color }, usePaletteStyles }) => {
    if (useNodeStyles) {
      return `
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
        z-index: 4;
        border-radius: 100%;
        background-color: ${color.whitePrimary};
      `
    }
    if (usePaletteStyles) {
      return `
        && {
          height: 24px;
          width: 24px;
          margin-right: 8px;
        }
      `
    }

    return ''
  }}
`

export const ErrorWarningIcon = styled(({ className }) => (
  <Icon
    className={className}
    icon="warning_solid"
    fill="errorPrimary"
    size="medium"
  />
))`
  && {
    width: 24px;
  }
  z-index: 2;
`
